var _a;
import { Ticket_Benefit_Category_Type } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Ticket_Benefit_Category_Type.Dental] = 'Dental',
    _a[Ticket_Benefit_Category_Type.Medical] = 'Medical',
    _a[Ticket_Benefit_Category_Type.Pharmacy] = 'Pharmacy',
    _a[Ticket_Benefit_Category_Type.Vision] = 'Vision',
    _a);
export var TicketBenefitCategoryTypeEnum = {
    name: 'Ticket_Benefit_Category_Type',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
